import { FunctionComponent } from 'react'

import { useTheme } from 'styled-components'

import translate, { Translations } from '@i18n'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import SectionHeader from '@components/SectionHeader'

interface TitleProps {
  id: keyof Translations
}

const Title: FunctionComponent<TitleProps> = ({ id }) => {
  const theme = useTheme()
  return (
    <SectionHeader
      title={translate(id)}
      isSubheader={true}
      accentColor={theme.colors.strokeBrand}
    />
  )
}

const widget = {
  kind: ['widget', 'title'],
  component: Title,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
